import React from "react";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExportContainer,
  GridCsvExportMenuItem,
} from "@mui/x-data-grid-pro";

export const GridToolbarTableButton = () => (
  <GridToolbarContainer id="mainGridButton">
    <div>
      {
        <GridToolbarColumnsButton
        //  disabled={rows.length === 0}
        />
      }
      {<GridToolbarFilterButton />}
      {<GridToolbarDensitySelector />}
      {
        <GridToolbarExportContainer>
          <GridCsvExportMenuItem />
        </GridToolbarExportContainer>
      }
    </div>
  </GridToolbarContainer>
);
